import type {ReactNode} from 'react'
import styles from './ReadOnlyConversationNotice.module.css'

export function ReadOnlyConversationNotice({
  message,
  action,
  error,
}: {
  message: ReactNode
  action?: ReactNode
  error?: string
}) {
  return (
    <div className={styles.Notice}>
      <div className={styles.Message}>{message}</div>
      {action}
      {error ? <p className={styles.Error}>{error}</p> : null}
    </div>
  )
}
